/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: XCe0uvfI3wKX

import * as React from "react";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { PlexusButton } from "../../components/plexus/PlexusButton"; // plasmic-import: sbyrU_8SkoWY/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicOrgSwitcher.module.css"; // plasmic-import: XCe0uvfI3wKX/css

import HomeSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__HomeSvg"; // plasmic-import: c8yr0PMQi/icon
import RocketSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__RocketSvg"; // plasmic-import: uRQfbBjV9/icon
import ChevronDownIcon from "../plasmic_kit_design_system/icons/PlasmicIcon__ChevronDown"; // plasmic-import: C21gcG8B3Wlx/icon
import SwitchSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__SwitchSvg"; // plasmic-import: vsY9_836a/icon
import PlusSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__PlusSvg"; // plasmic-import: sQKgd2GNr/icon

createPlasmicElementProxy;

export type PlasmicOrgSwitcher__VariantMembers = {
  canUpgrade: "canUpgrade";
  status: "paid" | "trial" | "trialEnded";
  hasNoOrg: "hasNoOrg";
};
export type PlasmicOrgSwitcher__VariantsArgs = {
  canUpgrade?: SingleBooleanChoiceArg<"canUpgrade">;
  status?: SingleChoiceArg<"paid" | "trial" | "trialEnded">;
  hasNoOrg?: SingleBooleanChoiceArg<"hasNoOrg">;
};
type VariantPropType = keyof PlasmicOrgSwitcher__VariantsArgs;
export const PlasmicOrgSwitcher__VariantProps = new Array<VariantPropType>(
  "canUpgrade",
  "status",
  "hasNoOrg"
);

export type PlasmicOrgSwitcher__ArgsType = {
  plan?: string;
  trialDaysLeft?: number;
  avatar?: React.ReactNode;
  name?: string;
};
type ArgPropType = keyof PlasmicOrgSwitcher__ArgsType;
export const PlasmicOrgSwitcher__ArgProps = new Array<ArgPropType>(
  "plan",
  "trialDaysLeft",
  "avatar",
  "name"
);

export type PlasmicOrgSwitcher__OverridesType = {
  root?: Flex__<"div">;
  freeText?: Flex__<"div">;
  trialText?: Flex__<"div">;
  span?: Flex__<"span">;
  trialEndedText?: Flex__<"div">;
  planText?: Flex__<"div">;
  upgradeBtn?: Flex__<typeof PlexusButton>;
  switchButton?: Flex__<typeof PlexusButton>;
  createOrgButton?: Flex__<typeof PlexusButton>;
};

export interface DefaultOrgSwitcherProps {
  plan?: string;
  trialDaysLeft?: number;
  avatar?: React.ReactNode;
  name?: string;
  canUpgrade?: SingleBooleanChoiceArg<"canUpgrade">;
  status?: SingleChoiceArg<"paid" | "trial" | "trialEnded">;
  hasNoOrg?: SingleBooleanChoiceArg<"hasNoOrg">;
  className?: string;
}

const $$ = {};

function PlasmicOrgSwitcher__RenderFunc(props: {
  variants: PlasmicOrgSwitcher__VariantsArgs;
  args: PlasmicOrgSwitcher__ArgsType;
  overrides: PlasmicOrgSwitcher__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "canUpgrade",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.canUpgrade
      },
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.status
      },
      {
        path: "hasNoOrg",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.hasNoOrg
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_ooL7EhXDmFQWnW9sxtchhE",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootcanUpgrade]: hasVariant($state, "canUpgrade", "canUpgrade"),
          [sty.roothasNoOrg]: hasVariant($state, "hasNoOrg", "hasNoOrg"),
          [sty.rootstatus_paid]: hasVariant($state, "status", "paid"),
          [sty.rootstatus_trialEnded]: hasVariant(
            $state,
            "status",
            "trialEnded"
          ),
          [sty.rootstatus_trial]: hasVariant($state, "status", "trial"),
          [sty.rootstatus_trial_canUpgrade]:
            hasVariant($state, "status", "trial") &&
            hasVariant($state, "canUpgrade", "canUpgrade")
        }
      )}
    >
      <div
        className={classNames("all", sty.freeBox__cuwCi, {
          [sty.freeBoxcanUpgrade__cuwCivduZy]: hasVariant(
            $state,
            "canUpgrade",
            "canUpgrade"
          ),
          [sty.freeBoxhasNoOrg__cuwCibJkBk]: hasVariant(
            $state,
            "hasNoOrg",
            "hasNoOrg"
          ),
          [sty.freeBoxstatus_paid__cuwCiLrWw9]: hasVariant(
            $state,
            "status",
            "paid"
          ),
          [sty.freeBoxstatus_trial__cuwCi1RBcc]: hasVariant(
            $state,
            "status",
            "trial"
          )
        })}
      >
        <div
          className={classNames("all", sty.freeBox__iEjBk, {
            [sty.freeBoxcanUpgrade__iEjBkvduZy]: hasVariant(
              $state,
              "canUpgrade",
              "canUpgrade"
            ),
            [sty.freeBoxhasNoOrg__iEjBkbJkBk]: hasVariant(
              $state,
              "hasNoOrg",
              "hasNoOrg"
            ),
            [sty.freeBoxstatus_paid__iEjBkLrWw9]: hasVariant(
              $state,
              "status",
              "paid"
            ),
            [sty.freeBoxstatus_trial__iEjBk1RBcc]: hasVariant(
              $state,
              "status",
              "trial"
            )
          })}
        >
          {(hasVariant($state, "hasNoOrg", "hasNoOrg") ? false : true)
            ? renderPlasmicSlot({
                defaultContents: (
                  <img
                    alt={""}
                    className={classNames(
                      "all",
                      "img",
                      "img__ooL7E",
                      sty.img__kMXyV
                    )}
                    loading={"lazy"}
                  />
                ),

                value: args.avatar
              })
            : null}
          {(hasVariant($state, "hasNoOrg", "hasNoOrg") ? true : false) ? (
            <HomeSvgIcon
              className={classNames("all", sty.svg__b8X3, {
                [sty.svgcanUpgrade__b8X3VduZy]: hasVariant(
                  $state,
                  "canUpgrade",
                  "canUpgrade"
                ),
                [sty.svghasNoOrg__b8X3BJkBk]: hasVariant(
                  $state,
                  "hasNoOrg",
                  "hasNoOrg"
                )
              })}
              role={"img"}
            />
          ) : null}
        </div>
        <div
          className={classNames("all", sty.freeBox__vdh5O, {
            [sty.freeBoxcanUpgrade__vdh5OvduZy]: hasVariant(
              $state,
              "canUpgrade",
              "canUpgrade"
            ),
            [sty.freeBoxstatus_paid__vdh5OLrWw9]: hasVariant(
              $state,
              "status",
              "paid"
            ),
            [sty.freeBoxstatus_trial__vdh5O1RBcc]: hasVariant(
              $state,
              "status",
              "trial"
            )
          })}
        >
          <div className={classNames("all", sty.freeBox__nxwib)}>
            <div
              className={classNames("all", "__wab_text", sty.text__jjbT0, {
                [sty.textcanUpgrade__jjbT0VduZy]: hasVariant(
                  $state,
                  "canUpgrade",
                  "canUpgrade"
                ),
                [sty.texthasNoOrg__jjbT0BJkBk]: hasVariant(
                  $state,
                  "hasNoOrg",
                  "hasNoOrg"
                ),
                [sty.textstatus_paid__jjbT0LrWw9]: hasVariant(
                  $state,
                  "status",
                  "paid"
                )
              })}
            >
              {hasVariant($state, "hasNoOrg", "hasNoOrg") ? (
                <React.Fragment>
                  {(() => {
                    try {
                      return `No organization yet`;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return "Untitled";
                      }
                      throw e;
                    }
                  })()}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {(() => {
                    try {
                      return $props.name;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return "Untitled";
                      }
                      throw e;
                    }
                  })()}
                </React.Fragment>
              )}
            </div>
          </div>
          {(hasVariant($state, "hasNoOrg", "hasNoOrg") ? true : false) ? (
            <div
              className={classNames("all", "__wab_text", sty.text__h8Ni, {
                [sty.texthasNoOrg__h8NIbJkBk]: hasVariant(
                  $state,
                  "hasNoOrg",
                  "hasNoOrg"
                )
              })}
            >
              {"Create one to start building projects with your team."}
            </div>
          ) : null}
          <div className={classNames("all", sty.freeBox___7K)}>
            <div className={classNames("all", sty.freeBox__pemOz)}>
              {(
                hasVariant($state, "hasNoOrg", "hasNoOrg")
                  ? false
                  : hasVariant($state, "status", "trialEnded")
                    ? false
                    : hasVariant($state, "status", "trial")
                      ? false
                      : hasVariant($state, "status", "paid")
                        ? false
                        : true
              ) ? (
                <div
                  data-plasmic-name={"freeText"}
                  data-plasmic-override={overrides.freeText}

                  className={classNames("all", "__wab_text", sty.freeText, {
                    [sty.freeTextcanUpgrade]: hasVariant(
                      $state,
                      "canUpgrade",
                      "canUpgrade"
                    ),
                    [sty.freeTexthasNoOrg]: hasVariant(
                      $state,
                      "hasNoOrg",
                      "hasNoOrg"
                    ),
                    [sty.freeTextstatus_paid]: hasVariant(
                      $state,
                      "status",
                      "paid"
                    ),
                    [sty.freeTextstatus_trialEnded]: hasVariant(
                      $state,
                      "status",
                      "trialEnded"
                    ),
                    [sty.freeTextstatus_trial]: hasVariant(
                      $state,
                      "status",
                      "trial"
                    )
                  })}
                >
                  {"Free plan"}
                </div>
              ) : null}
              {(
                hasVariant($state, "hasNoOrg", "hasNoOrg")
                  ? false
                  : hasVariant($state, "status", "trialEnded")
                    ? true
                    : hasVariant($state, "status", "trial")
                      ? true
                      : false
              ) ? (
                <div
                  data-plasmic-name={"trialText"}
                  data-plasmic-override={overrides.trialText}

                  className={classNames("all", "__wab_text", sty.trialText, {
                    [sty.trialTextcanUpgrade]: hasVariant(
                      $state,
                      "canUpgrade",
                      "canUpgrade"
                    ),
                    [sty.trialTexthasNoOrg]: hasVariant(
                      $state,
                      "hasNoOrg",
                      "hasNoOrg"
                    ),
                    [sty.trialTextstatus_paid]: hasVariant(
                      $state,
                      "status",
                      "paid"
                    ),
                    [sty.trialTextstatus_trialEnded]: hasVariant(
                      $state,
                      "status",
                      "trialEnded"
                    ),
                    [sty.trialTextstatus_trial]: hasVariant(
                      $state,
                      "status",
                      "trial"
                    )
                  })}
                >
                  <React.Fragment>
                    <React.Fragment>{"Trial \u00b7 "}</React.Fragment>
                    {
                      <span
                        data-plasmic-name={"span"}
                        data-plasmic-override={overrides.span}

                        className={classNames(
                          "all",
                          "span",
                          "span__ooL7E",
                          "__wab_text",
                          "plasmic_default__inline",
                          sty.span
                        )}
                      >
                        <React.Fragment>{$props.trialDaysLeft}</React.Fragment>
                      </span>
                    }
                    <React.Fragment>{" days left"}</React.Fragment>
                  </React.Fragment>
                </div>
              ) : null}
              {(hasVariant($state, "status", "trialEnded") ? true : false) ? (
                <div
                  data-plasmic-name={"trialEndedText"}
                  data-plasmic-override={overrides.trialEndedText}

                  className={classNames(
                    "all",
                    "__wab_text",
                    sty.trialEndedText,
                    {
                      [sty.trialEndedTexthasNoOrg]: hasVariant(
                        $state,
                        "hasNoOrg",
                        "hasNoOrg"
                      ),
                      [sty.trialEndedTextstatus_trialEnded]: hasVariant(
                        $state,
                        "status",
                        "trialEnded"
                      ),
                      [sty.trialEndedTextstatus_trial]: hasVariant(
                        $state,
                        "status",
                        "trial"
                      )
                    }
                  )}
                >
                  {"Trial ended"}
                </div>
              ) : null}
              {(
                hasVariant($state, "hasNoOrg", "hasNoOrg")
                  ? false
                  : hasVariant($state, "status", "paid")
                    ? true
                    : false
              ) ? (
                <div
                  data-plasmic-name={"planText"}
                  data-plasmic-override={overrides.planText}

                  className={classNames("all", "__wab_text", sty.planText, {
                    [sty.planTextcanUpgrade]: hasVariant(
                      $state,
                      "canUpgrade",
                      "canUpgrade"
                    ),
                    [sty.planTexthasNoOrg]: hasVariant(
                      $state,
                      "hasNoOrg",
                      "hasNoOrg"
                    ),
                    [sty.planTextstatus_paid]: hasVariant(
                      $state,
                      "status",
                      "paid"
                    ),
                    [sty.planTextstatus_trialEnded]: hasVariant(
                      $state,
                      "status",
                      "trialEnded"
                    ),
                    [sty.planTextstatus_trial]: hasVariant(
                      $state,
                      "status",
                      "trial"
                    )
                  })}
                >
                  <React.Fragment>
                    {(() => {
                      try {
                        return `${$props.plan} plan`;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return "plan";
                        }
                        throw e;
                      }
                    })()}
                  </React.Fragment>
                </div>
              ) : null}
            </div>
            {(hasVariant($state, "canUpgrade", "canUpgrade") ? true : false) ? (
              <PlexusButton
                data-plasmic-name={"upgradeBtn"}
                data-plasmic-override={overrides.upgradeBtn}

                className={classNames("__wab_instance", sty.upgradeBtn, {
                  [sty.upgradeBtncanUpgrade]: hasVariant(
                    $state,
                    "canUpgrade",
                    "canUpgrade"
                  ),
                  [sty.upgradeBtnhasNoOrg]: hasVariant(
                    $state,
                    "hasNoOrg",
                    "hasNoOrg"
                  )
                })}
                flatSide={[]}
                label={
                  <div
                    className={classNames("all", "__wab_text", sty.text__bwogG)}
                  >
                    {"Upgrade"}
                  </div>
                }
                size={"extraSmall"}
                start={
                  <RocketSvgIcon
                    className={classNames("all", sty.svg__gpc4E)}
                    role={"img"}
                  />
                }
                type={"clear"}
              />
            ) : null}
          </div>
        </div>
        {(hasVariant($state, "hasNoOrg", "hasNoOrg") ? false : true) ? (
          <PlexusButton
            data-plasmic-name={"switchButton"}
            data-plasmic-override={overrides.switchButton}

            ariaLabel={"Switch organization"}
            className={classNames("__wab_instance", sty.switchButton, {
              [sty.switchButtoncanUpgrade]: hasVariant(
                $state,
                "canUpgrade",
                "canUpgrade"
              ),
              [sty.switchButtonhasNoOrg]: hasVariant(
                $state,
                "hasNoOrg",
                "hasNoOrg"
              ),
              [sty.switchButtonstatus_trial]: hasVariant(
                $state,
                "status",
                "trial"
              )
            })}
            iconStart={true}
            label={null}
            size={"large"}
            start={
              <SwitchSvgIcon
                className={classNames("all", sty.svg__xPuF)}
                role={"img"}
              />
            }
            type={"clear"}
          />
        ) : null}
      </div>
      {(hasVariant($state, "hasNoOrg", "hasNoOrg") ? true : false) ? (
        <PlexusButton
          data-plasmic-name={"createOrgButton"}
          data-plasmic-override={overrides.createOrgButton}

          className={classNames("__wab_instance", sty.createOrgButton, {
            [sty.createOrgButtoncanUpgrade]: hasVariant(
              $state,
              "canUpgrade",
              "canUpgrade"
            ),
            [sty.createOrgButtonhasNoOrg]: hasVariant(
              $state,
              "hasNoOrg",
              "hasNoOrg"
            )
          })}
          iconStart={
            hasVariant($state, "hasNoOrg", "hasNoOrg") ? true : undefined
          }
          label={
            <div
              className={classNames("all", "__wab_text", sty.text___0Uh8X, {
                [sty.texthasNoOrg___0Uh8XbJkBk]: hasVariant(
                  $state,
                  "hasNoOrg",
                  "hasNoOrg"
                )
              })}
            >
              {"Create organization"}
            </div>
          }
          size={"small"}
          start={
            <PlusSvgIcon
              className={classNames("all", sty.svg__jaUxo)}
              role={"img"}
            />
          }
        />
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "freeText",
    "trialText",
    "span",
    "trialEndedText",
    "planText",
    "upgradeBtn",
    "switchButton",
    "createOrgButton"
  ],
  freeText: ["freeText"],
  trialText: ["trialText", "span"],
  span: ["span"],
  trialEndedText: ["trialEndedText"],
  planText: ["planText"],
  upgradeBtn: ["upgradeBtn"],
  switchButton: ["switchButton"],
  createOrgButton: ["createOrgButton"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeText: "div";
  trialText: "div";
  span: "span";
  trialEndedText: "div";
  planText: "div";
  upgradeBtn: typeof PlexusButton;
  switchButton: typeof PlexusButton;
  createOrgButton: typeof PlexusButton;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicOrgSwitcher__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicOrgSwitcher__VariantsArgs;
    args?: PlasmicOrgSwitcher__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicOrgSwitcher__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicOrgSwitcher__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOrgSwitcher__ArgProps,
          internalVariantPropNames: PlasmicOrgSwitcher__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOrgSwitcher__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOrgSwitcher";
  } else {
    func.displayName = `PlasmicOrgSwitcher.${nodeName}`;
  }
  return func;
}

export const PlasmicOrgSwitcher = Object.assign(
  // Top-level PlasmicOrgSwitcher renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeText: makeNodeComponent("freeText"),
    trialText: makeNodeComponent("trialText"),
    span: makeNodeComponent("span"),
    trialEndedText: makeNodeComponent("trialEndedText"),
    planText: makeNodeComponent("planText"),
    upgradeBtn: makeNodeComponent("upgradeBtn"),
    switchButton: makeNodeComponent("switchButton"),
    createOrgButton: makeNodeComponent("createOrgButton"),

    // Metadata about props expected for PlasmicOrgSwitcher
    internalVariantProps: PlasmicOrgSwitcher__VariantProps,
    internalArgProps: PlasmicOrgSwitcher__ArgProps
  }
);

export default PlasmicOrgSwitcher;
/* prettier-ignore-end */
